<template>
  <div class="mt-2">
    <WarningDisable permission="recon" />
    <div class="flex gap-6">
      <div>
        <form
          class="mb-4 space-y-4"
          @submit="submit_without_reloading"
          @reset="keyword = undefined"
        >
          <div class="space-y-2">
            <div>
              <legend>Từ khóa</legend>
              <label class="input w-full md:w-fit 2xl:w-fit">
                <i
                  class="fa-solid fa-magnifying-glass text-base-content/80"
                ></i>
                <input
                  type="text"
                  placeholder="Tìm kiếm theo từ khóa"
                  name="keyword"
                  v-model="keyword"
                />
              </label>
            </div>
          </div>
          <div class="flex flex-wrap gap-2">
            <input
              class="btn btn-outline grow"
              type="reset"
              value="&#8635; Đặt lại"
              :disabled="recon_store.loading.get_recons.value"
            />
            <button
              class="btn btn-primary btn-outline grow"
              type="submit"
              :disabled="
                !filter_has_changed || recon_store.loading.get_recons.value
              "
            >
              &#10003; Áp dụng
            </button>
          </div>
        </form>
      </div>

      <div class="flex grow flex-col overflow-x-auto">
        <div class="text-base-content/80 mb-2 text-xl font-bold">
          Danh sách thông tin
        </div>
        <Loading v-if="recon_store.loading.get_recons.value" />
        <template v-else-if="recon_store.total_filter.value > 0">
          <div class="bg-base-100 mb-4 overflow-x-auto">
            <table class="table-pin-rows table-md table">
              <thead>
                <tr>
                  <th></th>
                  <th>Danh mục</th>
                  <th>Tên</th>
                  <th>Detail 1</th>
                  <th>Detail 2</th>
                  <th>Detail 3</th>
                  <th>Đường dẫn</th>
                  <th>Thời gian tạo</th>
                  <th>Extra</th>
                </tr>
              </thead>
              <tbody class="bg-base-200">
                <tr
                  v-for="(item, idx) in recon_store.recon.value"
                  :key="item.id"
                >
                  <th>
                    {{
                      idx +
                      1 +
                      (number_from_query("page", 1) - 1) *
                        number_from_query("size", 24)
                    }}
                  </th>
                  <td>{{ item.category }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.detail_1 }}</td>
                  <td>{{ item.detail_2 }}</td>
                  <td>{{ item.detail_3 }}</td>
                  <td class="max-w-xs truncate" :title="item.path">
                    {{ item.path }}
                  </td>
                  <td>{{ dayjs(item.created_at).fromNow() }}</td>
                  <td>{{ item.extra }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <Pagination :total_pages="recon_store.total_pages.value" />
        </template>
        <NotFound v-else />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { number_from_query, str_from_query } from "@/api";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import Pagination from "@/components/PaginationTemplate.vue";
import { router } from "@/router/router";
import dayjs from "dayjs";
import { computed, ref } from "vue";
import WarningDisable from "../WarningDisable.vue";
import { use_recon } from "./useRecon";

const init_keyword = computed(() => str_from_query("keyword"));

const keyword = ref<string | undefined>(init_keyword.value);
const filter_has_changed = computed(() => keyword.value !== init_keyword.value);
const recon_store = use_recon();

const submit_without_reloading = (e: Event) => {
  e.preventDefault();
  router.push({
    name: router.currentRoute.value.name,
    query: {
      ...router.currentRoute.value.query,
      page: 1,
      keyword: keyword.value,
    },
  });
};
</script>
